import { auth } from '../auth/firebase';

interface ApiCallOptions {
  method?: string;
  body?: Record<string, unknown>;
  auth?: boolean;
}

export async function apiCall<T = Record<string, unknown>>(path: string, options: ApiCallOptions = {}): Promise<T> {
  const url = `/api${path}`;
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };

  if (options.auth !== false) {
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  const resp = await fetch(url, {
    method: options.method || 'GET',
    headers,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });

  let data: Record<string, unknown>;
  try {
    data = await resp.json();
  } catch {
    throw new Error(`Request failed (${resp.status})`);
  }
  if (!resp.ok) throw new Error((data.error as string) || `Request failed (${resp.status})`);
  return data as T;
}
